/** words-happen-gql's session endpoints, on the API's origin (apiOrigin). */
export const SESSION_PATHS = {
  /** POST { idToken, returnTo }: exchanges a Firebase ID token for the session cookies. */
  exchange: '/session',
  /** POST: clears the session cookies. */
  signOut: '/session/sign-out',
} as const;

/** The `errorCode` of a 403 from the session endpoints. */
export const SESSION_ERROR_CODES = {
  /** The account's email address isn't verified. */
  emailNotVerified: 'EMAIL_NOT_VERIFIED',
  /** The ID token is malformed, expired, revoked, from another project or for a disabled or deleted user. */
  tokenInvalid: 'TOKEN_INVALID',
  /** The ID token was issued more than 5 minutes ago: mint a fresh one and try again. */
  tokenStale: 'TOKEN_STALE',
  /** The request's Origin may not call this endpoint. */
  originNotAllowed: 'ORIGIN_NOT_ALLOWED',
} as const;

export type SessionErrorCode = (typeof SESSION_ERROR_CODES)[keyof typeof SESSION_ERROR_CODES];

/** The body of POST SESSION_PATHS.exchange. */
export interface SessionExchangeRequest {
  idToken: string;
  /** The return_to the identity app received, unvalidated; the API validates it. */
  returnTo?: string | null;
}

/** A 200 from POST SESSION_PATHS.exchange. The session token is only ever in the cookies. */
export interface SessionExchangeResponse {
  /** The validated return URL, or null when returnTo was missing or not allowed. */
  returnUrl: string | null;
}

/** A 403 from the session endpoints. */
export interface SessionErrorResponse {
  errorCode: SessionErrorCode;
  message: string;
}

/** The session endpoint URL on `apiOrigin`, e.g. https://api.wordshappen.dev/session. */
export const sessionUrl = (apiOrigin: string, path: (typeof SESSION_PATHS)[keyof typeof SESSION_PATHS]): string =>
  new URL(path, apiOrigin).href;
